<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import { computed } from 'vue'

import usei18n from '@/lib/i18n'

import type { Block } from './block'

const { block } = defineProps<{ block: Block<'completed' | 'failed' | 'cancelled'> }>()

const { _t } = usei18n()

function textOf(block: Block<'completed' | 'failed' | 'cancelled'>): string | null {
  switch (block.type) {
    case 'completed':
      return null
    case 'failed':
      return block.message
    case 'cancelled':
      return _t('Cancelled')
  }
}

const text = computed(() => textOf(block))
</script>

<template>
  <div v-if="text !== null" class="ai-block-turn-end">{{ text }}</div>
</template>

<style scoped>
.ai-block-turn-end {
  color: var(--font-color-dimmed);
}
</style>
